import { getDiscounts } from '@front/common/endpoints'
import { Discount } from '@front/common/types'
import { computed } from '@vue/composition-api'
import { useStore } from '@vueblocks/vue-use-vuex'

import useApiState from '@member-area/core/hooks/useApiState'
import useAuth from '@member-area/middleware/auth.hook'

import { INSERT_DISCOUNT } from './constants'

const useDiscount = () => {
  const store = useStore()

  const { auth } = useAuth()
  const [
    onFetchDiscountsSuccess,
    fetchDiscountsState,
    fetchDiscountsAction,
  ]: any[] = useApiState(getDiscounts)

  onFetchDiscountsSuccess((data) => {
    if (!data) {
      return
    }

    store.commit(INSERT_DISCOUNT, data)
  })

  const discounts = computed<Discount[]>(() => {
    return store.getters['discount/get']
  })

  async function fetchDiscounts() {
    return fetchDiscountsAction(auth.value.id)
  }

  return {
    discounts,
    fetchDiscountsState,
    fetchDiscounts,
  }
}

export default useDiscount
